module.exports = __webpack_public_path__ + "img/symbol_10.7d5ad909.png";